import {StoreMapType} from '../entity_datas/StoreEnums'
import {StoreExpansionType, LobbyImage} from '@colonist/types'
import {MapSettingEnum, ModeSettingEnum, ScenarioSettingEnum} from '../GameEnums'
import {TranslationObject} from '@colonist/i18n'

export abstract class BaseMapData {
    abstract premiumExpansionAccess: StoreExpansionType[] // Set to [] if free
    abstract premiumMapAccess: StoreMapType[] // Set to [] if free
    abstract mapEnum: MapSettingEnum
    abstract name: TranslationObject
    abstract image: LobbyImage
    abstract compatibleGameModes: ModeSettingEnum[]
    // compatibleScenarios: SomeFutureScenarioEnum[] // Dec 4, 2020. To be incluced with the room redesign
    // compatibleExtensions: SomeFutureExtensionEnum[] // Dec 4, 2020. To be included with the room redesign
    abstract includeInFreeMapRotationIfActive: boolean
    abstract isActive: boolean
    abstract numberOfLandTiles: number

    abstract scenario: ScenarioSettingEnum // Dec 4, 2020. To be included with the room redesign

    isMapPremium(): boolean {
        if(this.isMapRestrictedByPremiumGameMode()) return true
        if(this.isMapRestrictedByPremiumMap()) return true
        return false
    }

    isMapRestrictedByPremiumGameMode(): boolean {
        if(this.premiumExpansionAccess.length == 0) return false
        return true
    }

    isMapRestrictedByPremiumMap(): boolean {
        if(this.premiumMapAccess.length == 0) return false
        return true
    }

    getNewInstanceOfData(): BaseMapData {
        /* eslint-disable @typescript-eslint/prefer-function-type */
        const newInstance = new (this.constructor as {new (): BaseMapData})()
        return newInstance
    }
}
